module.exports = __webpack_public_path__ + "static/media/count.3c1ec986.png";